<!--
Copyright (C) 2026 Checkmk GmbH - License: Checkmk Enterprise License
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->

<script setup lang="ts">
import type { Block } from './block'

defineProps<{ block: Block<'prompt'> }>()
</script>

<template>
  <div class="ai-block-prompt">{{ block.text }}</div>
</template>

<style scoped>
.ai-block-prompt {
  width: fit-content;
  margin-left: auto;
  padding: var(--dimension-4);
  border-radius: var(--dimension-5);
  background-color: var(--default-form-element-bg-color);
}
</style>
